import React from 'react';
import './FindingDetails.css';

function TenantExecutiveFindingDetails({ finding }) {
  if (!finding) return null;

  const businessSummary =
    finding.businessSummary ||
    finding.business_summary ||
    finding.plain_language_description ||
    finding.summary ||
    'Summary pending review.';

  const impactText =
    finding.impact ||
    finding.why_it_matters ||
    'Potential exposure requires IT vendor review.';

  const complianceRefs = finding.compliance_refs || [];

  return (
    <div className="finding-details tenant-executive-finding-details">
      <div className="finding-details-item">
        <span className="finding-details-label">Business Summary</span>
        <p>{businessSummary}</p>
      </div>

      {(finding.file_path || finding.location) && (
        <div className="finding-details-item">
          <span className="finding-details-label">Location</span>
          <p style={{ fontFamily: 'monospace', fontSize: '13px', background: 'rgba(0,0,0,0.2)', padding: '4px', borderRadius: '4px' }}>
            {finding.file_path || finding.location} {finding.line_number ? `:L${finding.line_number}` : ''}
          </p>
        </div>
      )}

      <div className="finding-details-item">
        <span className="finding-details-label">Impact</span>
        <p>{impactText}</p>
      </div>

      {finding.code_snippet && (
        <div className="finding-details-item">
          <span className="finding-details-label">Evidence (Lines of Interest)</span>
          <pre className="gh-code-block" style={{ marginTop: '5px' }}>
            <code>{finding.code_snippet}</code>
          </pre>
        </div>
      )}

      {complianceRefs.length > 0 && (
        <div className="finding-details-item">
          <span className="finding-details-label">Compliance Mapping</span>
          <p>{complianceRefs.join(', ')}</p>
        </div>
      )}
    </div>
  );
}

export default TenantExecutiveFindingDetails;
